import PropTypes from "prop-types";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { Fragment } from "react";
import { Transition } from "components/common";


const SideDialogComponent = ({ open = false, handleCloseDialog = () => { }, children }) => {
  const theme = useTheme();
  const matchMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleCloseDialog}
      sx={{
        "&>div:nth-of-type(3)": {
          justifyContent: "flex-end",
          "&>div": {
            m: 0,
            borderRadius: "0px",
            width: matchMobile ? '100%' : 500,
            minHeight: "100%",
          },
          height: '100%',
        },
        zIndex: 1400,
      }}
    >
      {open && <Fragment>{children}</Fragment>}
    </Dialog>
  );
};

SideDialogComponent.propTypes = {
  open: PropTypes.bool,
  handleCloseDialog: PropTypes.func,
};

export default SideDialogComponent;
